import axios from "../http";

let module = "/attendance";

function getAttendance(data) {
    return axios.post(module+"/problems", data);
}

function getStudentAttendance(data) {
    return axios.post(module+"/"+data.studentId, data);
}
export default {
    getAttendance,getStudentAttendance
}
